import { Column, FMColumn, FileManagerRow } from '../model';
import { NameCell } from '../components/cells/NameCell';
import { Type } from '../../../../general/modules/filter/dataModel';
import { FVCString } from '../components/plugins/filters/FilterValueContainer';

// MYUA-17039: фильтр по имени — текстовый, по подстроке. Список всех имён
// с чекбоксами в большой папке бесполезен: искать нужное в нём дольше, чем
// набрать часть имени.
export const nameCol: FMColumn<Type.STRING> = {
  key: Column.name,
  dataKey: Column.name,
  title: 'Name',
  minWidth: 230,
  // Закреплена слева вместе с колонкой чекбокса — см. `selectorCol`.
  fixed: 'left',
  sortable: true,
  cellRenderer: NameCell,
  className: 'ch-file-manager__cell_name',
  filter: Type.STRING,
  plugins: [FVCString],
  // Раньше здесь был `row.id` — ключ enum-фильтра. Для текстового фильтра
  // ключ не нужен (сравнение идёт по `toDisplayString`), а сортировка этой
  // колонки getter не использует (`getTableData` берёт его только у
  // `secondaryColumns`); строка — по типу `Type.STRING`.
  getter: (row: FileManagerRow) => row.name,
  toDisplayString: (row) => row.name,
};
